import { Container, Sprite } from 'pixi.js';
import type { StarBlockerModel } from '../../../game/boardMVC/models/blockers/StarBlockerModel';
import type { BlockerView } from '../../../game/boardMVC/types';
import type { TileStackView } from '../../../game/boardMVC/views/board/TileStackView';
import { TILE_Z_OFFSET } from '../../../game/boardMVC/views/board/TileView';

export class EditorStarBlockerView extends Container implements BlockerView {
  private readonly starSprite = new Sprite().props({
    parent: this,
    texture: 'Blocker_Star_Floor',
    anchor: 0.5,
  });

  constructor(private readonly model: StarBlockerModel) {
    super();
  }

  public getModel(): StarBlockerModel {
    return this.model;
  }

  public setStackView(stackView: TileStackView): void {
    const callback = (): void => {
      const tilesAmount = stackView.model.getTiles().length;
      const y = tilesAmount * -TILE_Z_OFFSET;

      this.props({
        y,
        parent: stackView,
        addAbove: stackView.tiles,
      });

      this.starSprite.props({
        texture: y === 0 ? 'Blocker_Star_Floor' : 'Blocker_Star_Stack_Top',
      });
    };

    callback();

    stackView.model.onTilesAdded.connect(callback);
    stackView.model.onTilesRemoved.connect(callback);

    const cleanup = (): void => {
      stackView.model.onTilesAdded.disconnect(callback);
      stackView.model.onTilesRemoved.disconnect(callback);
    };

    stackView.once('destroyed', cleanup);
    this.once('destroyed', cleanup);
  }

  public async animateRemoval(): Promise<void> {
    //
  }
}
